
<mat-dialog-content class="dark">

  <div class="p-3 prose dark:prose-invert" [innerHTML]="data.markup">
  </div>
</mat-dialog-content>


<mat-dialog-actions >

  <div class="w-full flex flex-row justify-end">
    <button mat-flat-button color="primary" (click)="ok()">Ok</button>
    <button mat-button color="primary" (click)="cancel()">Cancel</button>
  </div>

</mat-dialog-actions>
